<template>
  <b-row>
    <b-col md="12">
      <div class="d-flex overflow-auto">
        <table class="table">
          <thead>
            <tr class="text-truncate">
              <th class="sticky-col text-center">#</th>
              <th class="text-truncate" >Trip Info</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Project</th>
              <th style="width:250px">POL Remark</th>
              <th style="width:250px">POD Remark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(val, index) in unfinishedTrip" :key="index" @click="tripId = val.tripRecord?.id" class="cursor-pointer">
              <td class="sticky-col text-center">
                <b-form-checkbox
                  :checked="tripId === val.tripRecord?.id"
                >
                </b-form-checkbox>
              </td>
              <td class="text-truncate">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center text-primary">
                    <i class="fas fa-map-pin mr-2"></i>
                    {{val?.tripRecord?.portLoading?.portName}}
                  </div> 
                  <div class="dashed-border"></div>
                  <div class="d-flex align-items-center text-primary">
                    <i class="fa fa-map-pin mr-2"></i>
                    {{val?.tripRecord?.portDischarge?.portName}}
                  </div>
                </div>
              </td>
              <td class="text-truncate">
                {{ val.tripRecord?.startDate ? moment(val.tripRecord?.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td> 
              <td class="text-truncate">
                {{ val.tripRecord?.endDate ? moment(val.tripRecord?.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td>  
              <td class="text-truncate">{{ val.tripRecord?.subProject.project.projectName }} - {{ val.tripRecord?.subProject?.name }}</td>
              <td class="text-left">{{ val.tripRecord?.polRemark }}</td>
              <td class="text-left">{{ val.tripRecord?.podRemark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-3" v-if="unfinishedTrip.length > 0">
        <b-pagination
          v-model="page"
          :total-rows="meta.total"
          :per-page="meta.perPage"
          first-number
          @change="fetchUnfinishTrip"
          align="center"
        />
      </div>
      <p v-else class="text-center my-4">List Trip tidak ada.</p>
    </b-col>

    <b-col md="12">
      <div class="d-flex align-items-center justify-content-end">
        <button
          type="button"
          class="btn btn-outline-primary btn-menu mr-2"
          @click="closeSidebar('assign-trip')"
        >
          Cancel & Close
        </button>

        <button
          type="button"
          class="btn btn-primary btn-menu"
          @click="onSaveSwapTrip"
        >
          Assign & Submit
        </button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { voyagesActions } from '@src/Utils/helper'
import LoadingOverlayFullscreen from '@src/components/LoadingOverlayFullscreen.vue'

export default {
  name:'SlideFormSwapTrip',
  props:{
    historiesParamsDate:{
      type:Array,
      default:() => []
    },   
    closeSidebar:{
      type:Function,
      default:() => {}
    },     
    activityTrip:{
      type:Object,
      default:() => {}
    },  
    refreshData:{
      type:Function,
      default:() => {}
    },  
  },
  components:{
    LoadingOverlayFullscreen
  },
  data(){
    return {
      unfinishedTrip: [],
      saving: false, 

      tripId: null,
      projectOptions: [],

      page:1,

      meta: {
        perPage: 0,
        currentPage: 0,
        total: 0,
        totalPage: 0,
        indexes: 1,
      },
    }
  },
  async mounted() {
    await this.fetchUnfinishTrip()
  },
  methods: {
    ...voyagesActions,
    resetForm(){
      this.tripId = null
    },
    formatString(str) {
      return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .toLowerCase()       // Convert to lowercase
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
    },
    async fetchUnfinishTrip (page = 1) {
      this.unfinishedTrip = []
      let params = {
        vehicleId: this.$route.query.vehicleId,
        page: page || 1,
      }

      const res = await this.getVoyageTrips(params)

      if (res.status == 'success') {
        // let vehicle = []
        res.data?.data?.map(val => {
          // vehicle = val.vehicle
          this.unfinishedTrip.push({
            ...val,
            checked:false
          })
        })

        this.meta.perPage = res.data?.perPage
        this.meta.currentPage = res.data?.currentPage
        this.meta.total = res.data?.total
        this.meta.totalPage = res?.data?.totalPage

        // vehicle?.filter((el, i) => el.id !== Number(this.$route.query?.vehicleId))
      }
    },

    async onSaveSwapTrip(){
      try {
        let destination = this.unfinishedTrip?.find(obj => obj.tripRecord?.id === this.tripId)
        let payload = {
          sourceTripId:this.activityTrip?.tripId,
          destinationTripId: destination?.tripRecord?.id,
          data: [
            {
              "voyageActivityId": this.activityTrip?.id
            },
          ]
        }

        this.saving = true

        const res = await this.swapTrip(payload)

        if (res.status === 'success') {
          this.$swal('Swap Trip!', res.data.message, 'success')
          this.resetForm()
          this.refreshData()
          this.closeSidebar('swap-trip')
        } else {
          if (res.data.message != null) {
            this.$swal('Error', res.data.message, 'error')
          } else {
            this.$swal(
              'Error',
              'Something wrong with the server. Please try again later.',
              'error'
            )
          }
        }

        this.saving = true
      } catch (err) {
        console.log(err)
        this.$swal('Error', err?.response?.data?.message || 'Something wrong with the server. Please try again later.', 'error')
        this.saving = false
      } finally {
        this.saving = false
      }
    }
  },
}
</script>

<style scoped>
.dashed-border {
  padding: 10px;
  border-left: 2px dashed black; /* Dashed left border */
  margin-left:3px
}
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
}
/* Column-specific left offsets */
.col-1 {
  left: 0;
  z-index: 3;
  min-width: 50px;
  max-width: 50px;
}
.col-2 {
  left: 50px; /* adjust this to match col-1 width */
  z-index: 3;
  min-width: 200px;
}
</style>